// GENERATED by scripts/generate-api-surface.mjs — do not edit.
// Source: openapi/spec.bundled.yaml
//
// What the two APIs offer, as the documentation page shows it. Generated so the
// page cannot claim an endpoint the contract does not have.

export interface ApiOperation {
  readonly operationId: string;
  readonly method: string;
  readonly path: string;
  readonly summary: string;
  readonly tags: readonly string[];
}

export interface ApiSurface {
  readonly title: string;
  readonly version: string;
  readonly summary: string;
  readonly operations: readonly ApiOperation[];
}

export interface EventSurface {
  readonly type: string;
  readonly schema: string;
  readonly summary: string;
}

export const domainApi: ApiSurface = {
  "title": "Betalingsservice API",
  "version": "1.0.0",
  "summary": "A modern JSON interface to Danish direct-debit (Betalingsservice).",
  "operations": [
    {
      "operationId": "submitCollectionBatch",
      "method": "POST",
      "path": "/v1/collection-batches",
      "summary": "Submit a batch of collections.",
      "tags": [
        "Collections"
      ]
    },
    {
      "operationId": "submitCollectionStops",
      "method": "POST",
      "path": "/v1/collection-stops",
      "summary": "Stop already-submitted collections.",
      "tags": [
        "Collections"
      ]
    },
    {
      "operationId": "submitMandateRegistrations",
      "method": "POST",
      "path": "/v1/mandate-registrations",
      "summary": "Register new mandates.",
      "tags": [
        "Mandates"
      ]
    },
    {
      "operationId": "submitCustomerNumberChanges",
      "method": "POST",
      "path": "/v1/customer-number-changes",
      "summary": "Change the customer number on existing mandates.",
      "tags": [
        "Mandates"
      ]
    },
    {
      "operationId": "submitMandateCancellations",
      "method": "POST",
      "path": "/v1/mandate-cancellations",
      "summary": "Cancel existing mandates.",
      "tags": [
        "Mandates"
      ]
    },
    {
      "operationId": "getHealth",
      "method": "GET",
      "path": "/v1/health",
      "summary": "Liveness probe.",
      "tags": [
        "System"
      ]
    }
  ]
};

export const domainEvents: readonly EventSurface[] = [
  {
    "type": "payment.advice",
    "schema": "PaymentAdviceEvent",
    "summary": "Delivered once per BS0602 advice file. `data.sections[]` are the per-creditor deposits the bank made, each with its per-charge outcomes — post one settlement per section, not one for the delivery."
  },
  {
    "type": "mandate.updated",
    "schema": "MandateDeliveryEvent",
    "summary": "Delivered once per BS0603 mandate file. Iterate `data.updates`; narrow each on its `kind`, and route each on its `creditor` — the example below is a real delivery carrying one mandate for PBS 30181557 and two for PBS 30185072."
  },
  {
    "type": "batch.accepted",
    "schema": "BatchReceiptEvent",
    "summary": "Delivered when the bank validates a submitted batch. Correlate via `data.deliveryReference` only when it is non-empty. Reference-less receipts cannot be deduplicated this way and must be kept."
  },
  {
    "type": "batch.rejected",
    "schema": "BatchReceiptEvent",
    "summary": "Delivered when the bank validates a submitted batch. Correlate via `data.deliveryReference` only when it is non-empty. Reference-less receipts cannot be deduplicated this way and must be kept."
  }
];

/** The bundled contract itself, for the API reference page. */
export const domainSpec: object = {
  "openapi": "3.1.0",
  "info": {
    "title": "Betalingsservice API",
    "version": "1.0.0",
    "summary": "A modern JSON interface to Danish direct-debit (Betalingsservice).",
    "description": "A clean REST facade over the Betalingsservice direct-debit rail. You work in\nplain domain terms — **collections** (the charges you raise), **mandates**\n(a payer's authorisation to be charged), **debtors** (the payers), and\n**payment outcomes** — and the service handles the underlying fixed-width\nfile exchange and SFTP transport for you. None of that transport detail\nsurfaces here.\n\nThe service is **fully stateless**: you submit a whole batch of collections in\none request and it builds and ships the delivery immediately. Inbound results\nfrom the bank (mandate changes, payment outcomes, batch validation receipts)\nare normalised into domain **events** and published to **Amazon EventBridge** —\nthe service keeps no subscriptions and no other state.\n\n## Access\nThe API is a **regional API Gateway**, locked to this AWS account by a resource\npolicy, with **IAM (SigV4) authorization**. Call its public endpoint with\nSigV4-signed requests from an IAM principal in the account that has invoke\npermission; there is no static API key or VPC endpoint requirement.\n\n## Amounts & dates\nAmounts are integer **minor units** (Danish øre) in a `Money` object. Dates\nare ISO-8601 (`YYYY-MM-DD`); timestamps are RFC-3339.\n\n## Idempotency\nEvery submitting endpoint takes a **`deliveryReference`** — it is both your\nreference and the **idempotency key**, and it is **required for a real submit**\n(omit it only on a `dryRun`, which has no side effect). The service ships each\nreference **at most once**: re-sending the same `deliveryReference` does not\ngenerate or ship a second file — it replays the original `202` response. This\nmakes a retry after a network timeout safe; without it, a duplicate delivery\nwould debit the payer twice. Use a fresh reference for genuinely new deliveries.\n\n## Events (EventBridge)\nAsync results are published to an EventBridge bus — **one event per inbound bank\nfile** (the service does no per-record splitting; the consumer iterates the records\ninside). Each event is delivered with `source: \"betalingsservice\"` and\n`detail-type` = the event type (e.g. `payment.advice`); the `detail` is the domain\nevent `{ id, type, occurredAt, data }`. The `EventBridgeEvent` schema documents the\nfull envelope. Consumers are wired up with EventBridge **rules** (in\ninfrastructure) — there is nothing to register through this API, and this is NOT an\nHTTP-webhook API.\n\n**Generating consumer types.** Either (1) from this contract, generate the\n`BetalingsserviceEvent` schema — a discriminated union — and `switch` on `type`;\nor (2) natively, the bus has **schema discovery** enabled, so the EventBridge\nSchema Registry auto-registers each event and you generate code bindings with\n`aws schemas`. The event `id` is a fresh UUID each time an inbound file is\nprocessed; reprocessing the same file creates a new id. Deduplicate on\n`type` + `data.subsystem` + `data.deliveryReference` only when the reference is\nnon-empty. This applies to BS0602 outcomes and BS0603 mandates when their\nreference exists, as well as receipts with a non-empty reference. Reference-less\nreceipts cannot be deduplicated this way and must be kept; their dedupe key is\nempty, rather than a shared key such as `batch.rejected:BS1:`.\nThe delivery reference is stable for the same file: the bank's `002`/`992`\ndelivery identification for advice/mandates, or the receipt's delivery reference\n(see `BatchReceipt`).\n\n| Event `type` | Maps from | Carries |\n| --- | --- | --- |\n| `payment.advice` | one BS0602 advice | every collection outcome (`sections[].collections[].outcome` = settled / rejected / cancelled / charged_back) + the per-creditor deposits in `sections` |\n| `mandate.updated` | one BS0603 delivery | every mandate change (`updates[].kind` = registered / active / cancelled) |\n| `batch.accepted` / `batch.rejected` | a PBCNET41 receipt | the bank's validation of a submitted batch |\n\n**One delivery, several creditors.** The bank packs a section per creditor into a\nsingle file, so an inbound event routinely spans more than one. Each payment\nsection (`sections[]`) and mandate update (`updates[]`) carries its own\n`creditor` (`pbsNumber` + `debtorGroupNumber`), and `payment.advice` reports one\nentry in `sections` per creditor because the bank pays each of them separately.\n\nThis is not cosmetic: **customer and mandate numbers are assigned by the creditor,\nso they are only unique within one.** Resolve a debtor on\n`(creditor.pbsNumber, debtor.customerNumber)` — looking up on `customerNumber`\nalone will eventually attach a mandate to the wrong creditor's customer.\n\n\n# Event reference\n\nThe discriminated union of every event the service publishes — ONE event per\ninbound file (the service does no per-record splitting). Generate this type and\nswitch exhaustively on `type`. Each event is published to EventBridge with\n`detail-type` equal to `type` and this object as the `detail`.\n\n\n## The envelope\n\nThe full event as delivered by Amazon EventBridge — this is what an EventBridge\nrule target receives. Pattern-match on `source` + `detail-type`; the `detail` is\nthe domain event (`BetalingsserviceEvent`). `detail-type` equals `detail.type`.\n\n\n<SchemaDefinition schemaRef=\"#/components/schemas/EventBridgeEvent\" />\n\n## payment.advice\n\nDelivered once per BS0602 advice file. `data.sections[]` are the per-creditor\ndeposits the bank made, each with its per-charge outcomes — post one settlement\nper section, not one for the delivery.\n\n\n<SchemaDefinition schemaRef=\"#/components/schemas/PaymentAdviceEvent\" />\n\n## mandate.updated\n\nDelivered once per BS0603 mandate file. Iterate `data.updates`; narrow each on\nits `kind`, and route each on its `creditor` — the example below is a real\ndelivery carrying one mandate for PBS 30181557 and two for PBS 30185072.\n\n\n<SchemaDefinition schemaRef=\"#/components/schemas/MandateDeliveryEvent\" />\n\n## batch.accepted\n\nDelivered when the bank validates a submitted batch. Correlate via\n`data.deliveryReference` only when it is non-empty. Reference-less receipts\ncannot be deduplicated this way and must be kept.\n\n\n<SchemaDefinition schemaRef=\"#/components/schemas/BatchReceiptEvent\" />\n\n## batch.rejected\n\nDelivered when the bank validates a submitted batch. Correlate via\n`data.deliveryReference` only when it is non-empty. Reference-less receipts\ncannot be deduplicated this way and must be kept.\n\n\n<SchemaDefinition schemaRef=\"#/components/schemas/BatchReceiptEvent\" />\n",
    "contact": {
      "name": "Betalingsservice API support",
      "url": "https://example.com/support"
    },
    "license": {
      "name": "Proprietary",
      "identifier": "LicenseRef-Proprietary"
    }
  },
  "servers": [
    {
      "url": "https://api.betalingsservice.example.com",
      "description": "Production."
    },
    {
      "url": "https://sandbox.api.betalingsservice.example.com",
      "description": "Sandbox."
    }
  ],
  "tags": [
    {
      "name": "Collections",
      "description": "Raise direct-debit charges against payer mandates."
    },
    {
      "name": "Mandates",
      "description": "Register, change, and cancel payer mandates."
    },
    {
      "name": "System",
      "description": "Operational endpoints."
    }
  ],
  "paths": {
    "/v1/collection-batches": {
      "post": {
        "operationId": "submitCollectionBatch",
        "summary": "Submit a batch of collections.",
        "description": "Raises every collection in the batch as one delivery. The service builds the\ndelivery and ships it to the bank in-request, then returns the result. Pass\n`dryRun=true` to build and return a preview **without** shipping — the safe\nway to check what would be sent.\n",
        "tags": [
          "Collections"
        ],
        "parameters": [
          {
            "name": "dryRun",
            "in": "query",
            "required": false,
            "schema": {
              "type": "boolean",
              "default": false
            },
            "description": "Build and return the delivery without shipping it."
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CollectionBatch"
              }
            }
          }
        },
        "responses": {
          "202": {
            "description": "The batch was accepted; the delivery was built (and shipped unless dry run).",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Delivery"
                }
              }
            }
          },
          "400": {
            "$ref": "#/components/responses/BadRequest"
          },
          "500": {
            "$ref": "#/components/responses/InternalError"
          }
        }
      }
    },
    "/v1/collection-stops": {
      "post": {
        "operationId": "submitCollectionStops",
        "summary": "Stop already-submitted collections.",
        "description": "Requests a stop on collections that have already been delivered to the bank\n(up to one banking day before the due date). Stateless: you identify each\ncollection by the same fields you sent originally. Pass `dryRun=true` to build\nthe stop delivery without shipping it.\n",
        "tags": [
          "Collections"
        ],
        "parameters": [
          {
            "name": "dryRun",
            "in": "query",
            "required": false,
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/StopBatch"
              }
            }
          }
        },
        "responses": {
          "202": {
            "description": "The stop requests were accepted (and shipped unless dry run).",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/StopReceipt"
                }
              }
            }
          },
          "400": {
            "$ref": "#/components/responses/BadRequest"
          },
          "500": {
            "$ref": "#/components/responses/InternalError"
          }
        }
      }
    },
    "/v1/mandate-registrations": {
      "post": {
        "operationId": "submitMandateRegistrations",
        "summary": "Register new mandates.",
        "description": "Registers one or more direct-debit mandates — either from the payer's bank\ndetails or copied from an existing mandate. Stateless: the whole batch is built\ninto a single delivery and shipped. Pass `dryRun=true` to build the delivery\nwithout shipping it.\n",
        "tags": [
          "Mandates"
        ],
        "parameters": [
          {
            "name": "dryRun",
            "in": "query",
            "required": false,
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/MandateRegistrationBatch"
              }
            }
          }
        },
        "responses": {
          "202": {
            "description": "The registrations were accepted (and shipped unless dry run).",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/MandateReceipt"
                }
              }
            }
          },
          "400": {
            "$ref": "#/components/responses/BadRequest"
          },
          "500": {
            "$ref": "#/components/responses/InternalError"
          }
        }
      }
    },
    "/v1/customer-number-changes": {
      "post": {
        "operationId": "submitCustomerNumberChanges",
        "summary": "Change the customer number on existing mandates.",
        "description": "Updates the customer number a mandate is registered under, so it matches a\nchange you made in your own system. Stateless: the whole batch is built into a\nsingle delivery and shipped. Pass `dryRun=true` to build the delivery without\nshipping it.\n",
        "tags": [
          "Mandates"
        ],
        "parameters": [
          {
            "name": "dryRun",
            "in": "query",
            "required": false,
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/CustomerNumberChangeBatch"
              }
            }
          }
        },
        "responses": {
          "202": {
            "description": "The changes were accepted (and shipped unless dry run).",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/MandateReceipt"
                }
              }
            }
          },
          "400": {
            "$ref": "#/components/responses/BadRequest"
          },
          "500": {
            "$ref": "#/components/responses/InternalError"
          }
        }
      }
    },
    "/v1/mandate-cancellations": {
      "post": {
        "operationId": "submitMandateCancellations",
        "summary": "Cancel existing mandates.",
        "description": "Cancels one or more direct-debit mandates — because the customer relationship\nended or the customer number is unknown. Stateless: the whole batch is built\ninto a single delivery and shipped. Pass `dryRun=true` to build the delivery\nwithout shipping it.\n",
        "tags": [
          "Mandates"
        ],
        "parameters": [
          {
            "name": "dryRun",
            "in": "query",
            "required": false,
            "schema": {
              "type": "boolean",
              "default": false
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/MandateCancellationBatch"
              }
            }
          }
        },
        "responses": {
          "202": {
            "description": "The cancellations were accepted (and shipped unless dry run).",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/MandateReceipt"
                }
              }
            }
          },
          "400": {
            "$ref": "#/components/responses/BadRequest"
          },
          "500": {
            "$ref": "#/components/responses/InternalError"
          }
        }
      }
    },
    "/v1/health": {
      "get": {
        "operationId": "getHealth",
        "summary": "Liveness probe.",
        "tags": [
          "System"
        ],
        "responses": {
          "200": {
            "description": "The service is up.",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Health"
                }
              }
            }
          }
        }
      }
    }
  },
  "components": {
    "schemas": {
      "EventBridgeEvent": {
        "type": "object",
        "description": "The full event as delivered by Amazon EventBridge — this is what an EventBridge\nrule target receives. Pattern-match on `source` + `detail-type`; the `detail` is\nthe domain event (`BetalingsserviceEvent`). `detail-type` equals `detail.type`.\n",
        "required": [
          "source",
          "detail-type",
          "detail"
        ],
        "properties": {
          "version": {
            "type": "string",
            "examples": [
              "0"
            ]
          },
          "id": {
            "type": "string",
            "description": "The EventBridge event id (distinct from the domain event id)."
          },
          "source": {
            "type": "string",
            "const": "betalingsservice"
          },
          "detail-type": {
            "type": "string",
            "description": "Equals the domain event `type`.",
            "enum": [
              "payment.advice",
              "mandate.updated",
              "batch.accepted",
              "batch.rejected"
            ]
          },
          "account": {
            "type": "string"
          },
          "time": {
            "type": "string",
            "format": "date-time"
          },
          "region": {
            "type": "string"
          },
          "resources": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "detail": {
            "$ref": "#/components/schemas/BetalingsserviceEvent"
          }
        }
      },
      "BetalingsserviceEvent": {
        "description": "The discriminated union of every event the service publishes — ONE event per\ninbound file (the service does no per-record splitting). Generate this type and\nswitch exhaustively on `type`. Each event is published to EventBridge with\n`detail-type` equal to `type` and this object as the `detail`.\n",
        "oneOf": [
          {
            "$ref": "#/components/schemas/PaymentAdviceEvent"
          },
          {
            "$ref": "#/components/schemas/MandateDeliveryEvent"
          },
          {
            "$ref": "#/components/schemas/BatchReceiptEvent"
          }
        ],
        "discriminator": {
          "propertyName": "type",
          "mapping": {
            "payment.advice": "#/components/schemas/PaymentAdviceEvent",
            "mandate.updated": "#/components/schemas/MandateDeliveryEvent",
            "batch.accepted": "#/components/schemas/BatchReceiptEvent",
            "batch.rejected": "#/components/schemas/BatchReceiptEvent"
          }
        }
      },
      "Subsystem": {
        "type": "string",
        "pattern": "^[A-Za-z0-9]{1,3}$",
        "description": "The Betalingsservice subsystem identifier the bank agreed for a data-supplier\nlogin, written into the 002 record of every delivery (`BS1`, `BS2`; test\nagreements use their own, such as `KR9`).\n\n**It selects the mailbox.** This service carries one SFTP login per subsystem,\nand the same PBS number can be registered under more than one of them, so the\nsubsystem — not the creditor — decides which login a delivery ships through\nand which login an inbound file was fetched from. A subsystem whose mailbox is\nnot enabled in this environment is refused with `mailbox_not_enabled` rather\nthan stored where nothing would ship it.\n",
        "examples": [
          "BS2"
        ]
      },
      "Creditor": {
        "type": "object",
        "description": "The party raising the charges (you, or an account you bill for).\n\nA creditor is `(pbsNumber, debtorGroupNumber)`, not a PBS number alone — the\nbank files one section per pair, and customer and mandate numbers are only\nunique within one. Both halves are required for the same reason: a delivery\nfiled under the wrong group cites customer numbers the bank has never seen\nthere.\n",
        "required": [
          "pbsNumber",
          "debtorGroupNumber",
          "dataSupplierNumber",
          "subsystem"
        ],
        "additionalProperties": false,
        "properties": {
          "pbsNumber": {
            "type": "string",
            "pattern": "^\\d{1,8}$",
            "description": "Your Betalingsservice creditor number (up to 8 digits).",
            "examples": [
              "30028899"
            ]
          },
          "debtorGroupNumber": {
            "type": "string",
            "pattern": "^[1-9]\\d{0,4}$",
            "description": "The debtor group within that creditor, as registered with\nBetalingsservice.\n\nAlmost always `\"1\"`, but deliberately not defaulted: a creditor that\nsegments its debtors registers its mandates elsewhere (one real creditor\nuses group 147), and guessing 1 for them produces a file the bank cannot\nmatch to a single payer. Send what the creditor's agreement says.\n",
            "examples": [
              "1"
            ]
          },
          "dataSupplierNumber": {
            "type": "string",
            "pattern": "^\\d{8}$",
            "description": "The registered CVR of the party delivering the batch (8 digits).",
            "examples": [
              "40523375"
            ]
          },
          "subsystem": {
            "$ref": "#/components/schemas/Subsystem"
          },
          "dataSupplierIdentification": {
            "type": "string",
            "maxLength": 15,
            "description": "An optional label identifying the batch's origin."
          }
        }
      },
      "Address": {
        "type": "object",
        "description": "A payer's postal address (only what Betalingsservice records).",
        "required": [
          "postcode"
        ],
        "additionalProperties": false,
        "properties": {
          "postcode": {
            "type": "string",
            "pattern": "^\\d{4}$",
            "description": "Danish 4-digit postcode.",
            "examples": [
              "2100"
            ]
          },
          "country": {
            "type": "string",
            "pattern": "^[A-Z]{2}$",
            "default": "DK",
            "description": "ISO-3166 alpha-2 country code. Optional; defaults to DK.",
            "examples": [
              "DK"
            ]
          }
        }
      },
      "Debtor": {
        "type": "object",
        "description": "The payer being charged.",
        "required": [
          "customerNumber",
          "name"
        ],
        "additionalProperties": false,
        "properties": {
          "customerNumber": {
            "type": "string",
            "minLength": 1,
            "maxLength": 15,
            "pattern": "^[A-Za-z0-9]+$",
            "description": "Your own identifier for this payer (stable across charges).",
            "examples": [
              "1000042"
            ]
          },
          "name": {
            "type": "string",
            "minLength": 1,
            "maxLength": 35,
            "description": "The payer's name as it should appear to them.",
            "examples": [
              "Jens Hansen"
            ]
          },
          "address": {
            "$ref": "#/components/schemas/Address"
          },
          "registrationId": {
            "type": "string",
            "pattern": "^\\d{8}(\\d{2})?$",
            "description": "The payer's CVR (8 digits) or CPR (10 digits) number, if known."
          }
        }
      },
      "Money": {
        "type": "object",
        "description": "A monetary amount in minor units (Danish øre — 1 DKK = 100 øre).",
        "required": [
          "currency",
          "minorUnits"
        ],
        "additionalProperties": false,
        "properties": {
          "currency": {
            "type": "string",
            "enum": [
              "DKK"
            ],
            "description": "ISO-4217 currency code. Betalingsservice is DKK-only."
          },
          "minorUnits": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9999999999999,
            "description": "Amount in øre. E.g. 26395 = 263.95 DKK. (Safely within 2^53.)",
            "examples": [
              26395
            ]
          }
        }
      },
      "ChargeType": {
        "type": "string",
        "description": "How the charge is presented to the payer. `automatic` is a normal direct\ndebit collected from the payer's account; `payment_slip` produces a payable\nslip instead.\n",
        "enum": [
          "automatic",
          "payment_slip"
        ],
        "default": "automatic"
      },
      "Collection": {
        "type": "object",
        "description": "A single direct-debit charge raised against a payer's mandate.\n\n**Text is written in ISO-8859-1**, the bank's file encoding, so Danish\nletters (æ, ø, å) and other Western European ones are fine. `advice` and\n`separateAdvice` are written whatever characters they hold (a line may still\nbe at most 60 characters as sent): common characters that encoding lacks\nare replaced (curly quotes become straight ones, dashes become `-`, `…`\nbecomes `...` and `€` becomes `EUR`), any other character outside\nISO-8859-1 (an emoji, say) becomes `?`, a control character such as a line\nbreak becomes a space, and a line the replacements made longer than 60 is\ncut to 60. `filePreview` shows the text as written.\n\n`reference` is never rewritten: it comes back on payment events, so a\nreference that would need any of those replacements is refused with 400\n`unwritable_character` instead, and one longer than the bank returns (9\ncharacters for a `payment_slip`) with 400 `validation_error`.\n",
        "required": [
          "mandateNumber",
          "debtor",
          "amount",
          "dueDate",
          "reference"
        ],
        "additionalProperties": false,
        "properties": {
          "mandateNumber": {
            "type": "string",
            "pattern": "^\\d{1,9}$",
            "description": "The mandate authorising this charge (up to 9 digits). `0` for a payment made\nby payment slip (§0215, outcome from a 0297/0299 record), which involves no\nmandate.\n",
            "examples": [
              "94557"
            ]
          },
          "debtor": {
            "$ref": "#/components/schemas/Debtor"
          },
          "amount": {
            "$ref": "#/components/schemas/Money"
          },
          "dueDate": {
            "type": "string",
            "format": "date",
            "description": "The date the charge should be collected (ISO-8601). It **must** be a valid\nBetalingsservice collection date — a banking day within the allowed lead-time\nwindow. Those rules (banking days, public holidays, cutoff times) change over\ntime and are the caller's responsibility; this service does not compute them.\nA non-conforming date is rejected by the bank and surfaced as a\n`collection.rejected` / `batch.rejected` event. The only check here is that\nthe date is not in the past.\n",
            "examples": [
              "2026-08-01"
            ]
          },
          "reference": {
            "type": "string",
            "minLength": 1,
            "maxLength": 30,
            "description": "Your reference for this charge. It is carried through and echoed back on\nevery payment outcome event, so use it to correlate.\n\nFor a `payment_slip` charge it may be at most 9 characters: the bank's\npayment-slip record holds 9, and only those come back. A longer one is\nrefused with 400 `validation_error` rather than cut.\n",
            "examples": [
              "INV-2026-000042"
            ]
          },
          "chargeType": {
            "$ref": "#/components/schemas/ChargeType"
          },
          "advice": {
            "type": "array",
            "description": "Statement text shown to the payer for this charge.",
            "maxItems": 10,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 60
            }
          },
          "separateAdvice": {
            "type": "array",
            "description": "Additional text printed on the payment slip (when applicable).",
            "maxItems": 10,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 60
            }
          }
        }
      },
      "CollectionBatch": {
        "type": "object",
        "description": "A batch of collections to raise in one delivery.",
        "required": [
          "creditor",
          "collections"
        ],
        "additionalProperties": false,
        "properties": {
          "creditor": {
            "$ref": "#/components/schemas/Creditor"
          },
          "deliveryReference": {
            "type": "string",
            "minLength": 1,
            "maxLength": 35,
            "description": "Your reference for the whole delivery and the idempotency key. Required for\na real submit (see Idempotency); re-sending the same value replays the\noriginal result and ships nothing new. Optional on a dryRun.\n"
          },
          "collections": {
            "type": "array",
            "minItems": 1,
            "maxItems": 10000,
            "items": {
              "$ref": "#/components/schemas/Collection"
            }
          }
        }
      },
      "DeliveryLine": {
        "type": "object",
        "description": "One accepted collection, echoed back with its resolved reference.",
        "required": [
          "reference",
          "mandateNumber",
          "amount"
        ],
        "additionalProperties": false,
        "properties": {
          "reference": {
            "type": "string"
          },
          "mandateNumber": {
            "type": "string"
          },
          "amount": {
            "$ref": "#/components/schemas/Money"
          }
        }
      },
      "Delivery": {
        "type": "object",
        "description": "The result of submitting a collection batch.",
        "required": [
          "deliveryReference",
          "status",
          "acceptedCount",
          "totalAmount",
          "dueDates",
          "storedAt",
          "lines",
          "filePreview"
        ],
        "additionalProperties": false,
        "properties": {
          "deliveryReference": {
            "type": "string",
            "description": "The delivery's reference (generated if you did not supply one)."
          },
          "status": {
            "type": "string",
            "enum": [
              "stored",
              "generated"
            ],
            "description": "`stored` — the delivery was built and written to outbound storage; a 2xx\nhere means it is safely persisted and **will be delivered to the bank\nasynchronously over SFTP**. `generated` — built and returned for inspection\nonly (a dry run), not stored. A storage failure is a 5xx error, not a status.\n"
          },
          "acceptedCount": {
            "type": "integer",
            "minimum": 0,
            "description": "Number of collections included in the delivery."
          },
          "totalAmount": {
            "$ref": "#/components/schemas/Money"
          },
          "dueDates": {
            "type": "array",
            "uniqueItems": true,
            "items": {
              "type": "string",
              "format": "date"
            },
            "description": "The distinct due dates covered by this delivery."
          },
          "storedAt": {
            "type": [
              "string",
              "null"
            ],
            "format": "date-time",
            "description": "When the delivery was written to outbound storage. Null on a dry run."
          },
          "lines": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/DeliveryLine"
            }
          },
          "filePreview": {
            "type": [
              "string",
              "null"
            ],
            "description": "On a dry run, the generated delivery as text — for inspection only. Null\non a real submission.\n"
          }
        }
      },
      "Problem": {
        "type": "object",
        "description": "An RFC-7807 problem response (`application/problem+json`).",
        "required": [
          "type",
          "title",
          "status"
        ],
        "properties": {
          "type": {
            "type": "string",
            "format": "uri-reference",
            "description": "A URI reference identifying the problem type.",
            "default": "about:blank"
          },
          "title": {
            "type": "string",
            "description": "A short, human-readable summary of the problem."
          },
          "status": {
            "type": "integer",
            "minimum": 100,
            "maximum": 599,
            "description": "The HTTP status code, repeated for convenience."
          },
          "detail": {
            "type": "string",
            "description": "A human-readable explanation specific to this occurrence."
          },
          "code": {
            "type": "string",
            "description": "A stable machine-readable code (e.g. validation_error, not_found)."
          },
          "instance": {
            "type": "string",
            "format": "uri-reference",
            "description": "A URI reference identifying the specific occurrence."
          }
        },
        "examples": [
          {
            "type": "about:blank",
            "title": "Request validation failed",
            "status": 400,
            "detail": "collections: array must contain at least 1 element(s)",
            "code": "validation_error"
          }
        ]
      },
      "CollectionStop": {
        "type": "object",
        "description": "Identifies a previously-submitted collection to stop. Stateless — you supply\nthe same identifying fields you sent on the collection (the service stores\nnothing to look them up by). The bank matches on debtor + mandate + due date.\n",
        "required": [
          "debtor",
          "mandateNumber",
          "dueDate"
        ],
        "additionalProperties": false,
        "properties": {
          "debtor": {
            "type": "object",
            "required": [
              "customerNumber"
            ],
            "additionalProperties": false,
            "properties": {
              "customerNumber": {
                "type": "string",
                "minLength": 1,
                "maxLength": 15,
                "pattern": "^[A-Za-z0-9]+$"
              }
            }
          },
          "mandateNumber": {
            "type": "string",
            "pattern": "^\\d{1,9}$"
          },
          "dueDate": {
            "type": "string",
            "format": "date",
            "description": "The due date of the collection to stop."
          },
          "reference": {
            "type": "string",
            "minLength": 1,
            "maxLength": 30,
            "description": "Your original reference, echoed back for correlation (not sent to the bank)."
          }
        }
      },
      "StopBatch": {
        "type": "object",
        "description": "A batch of stop requests for already-submitted collections.",
        "required": [
          "creditor",
          "stops"
        ],
        "additionalProperties": false,
        "properties": {
          "creditor": {
            "$ref": "#/components/schemas/Creditor"
          },
          "deliveryReference": {
            "type": "string",
            "minLength": 1,
            "maxLength": 35,
            "description": "Your reference for the whole delivery and the idempotency key. Required for\na real submit (see Idempotency); re-sending the same value replays the\noriginal result and ships nothing new. Optional on a dryRun.\n"
          },
          "stops": {
            "type": "array",
            "minItems": 1,
            "maxItems": 10000,
            "items": {
              "$ref": "#/components/schemas/CollectionStop"
            }
          }
        }
      },
      "StopReceipt": {
        "type": "object",
        "description": "The result of submitting a batch of stop requests.",
        "required": [
          "deliveryReference",
          "status",
          "acceptedCount",
          "storedAt",
          "stops",
          "filePreview"
        ],
        "additionalProperties": false,
        "properties": {
          "deliveryReference": {
            "type": "string"
          },
          "status": {
            "type": "string",
            "enum": [
              "stored",
              "generated"
            ],
            "description": "`stored` — written to outbound storage, delivered to the bank asynchronously\nover SFTP. `generated` — a dry run, not stored.\n"
          },
          "acceptedCount": {
            "type": "integer",
            "minimum": 0
          },
          "storedAt": {
            "type": [
              "string",
              "null"
            ],
            "format": "date-time"
          },
          "stops": {
            "type": "array",
            "items": {
              "type": "object",
              "required": [
                "mandateNumber",
                "customerNumber"
              ],
              "additionalProperties": false,
              "properties": {
                "mandateNumber": {
                  "type": "string"
                },
                "customerNumber": {
                  "type": "string"
                },
                "reference": {
                  "type": [
                    "string",
                    "null"
                  ]
                }
              }
            }
          },
          "filePreview": {
            "type": [
              "string",
              "null"
            ],
            "description": "On a dry run, the generated stop delivery as text. Null on a real submission."
          }
        }
      },
      "BankAccount": {
        "type": "object",
        "description": "A Danish bank account — a registration (sort) number and an account number.",
        "required": [
          "registrationNumber",
          "accountNumber"
        ],
        "additionalProperties": false,
        "properties": {
          "registrationNumber": {
            "type": "string",
            "pattern": "^\\d{1,4}$",
            "description": "The 4-digit bank registration (sort) number.",
            "examples": [
              "1234"
            ]
          },
          "accountNumber": {
            "type": "string",
            "pattern": "^\\d{1,10}$",
            "description": "The account number (up to 10 digits).",
            "examples": [
              "0001234567"
            ]
          }
        }
      },
      "NewMandateRegistration": {
        "type": "object",
        "description": "Register a brand-new mandate from the payer's identity and bank account.",
        "required": [
          "basis",
          "customerNumber",
          "registrationId",
          "bankAccount"
        ],
        "additionalProperties": false,
        "properties": {
          "basis": {
            "type": "string",
            "enum": [
              "bank_account"
            ],
            "description": "Registers a fresh mandate from the payer's bank account details."
          },
          "customerNumber": {
            "type": "string",
            "minLength": 1,
            "maxLength": 15,
            "pattern": "^[A-Za-z0-9]+$",
            "description": "Your own identifier for this payer.",
            "examples": [
              "1000042"
            ]
          },
          "registrationId": {
            "type": "string",
            "pattern": "^\\d{8}(\\d{2})?$",
            "description": "The payer's CVR (8 digits) or CPR (10 digits) number."
          },
          "bankAccount": {
            "$ref": "#/components/schemas/BankAccount"
          }
        }
      },
      "MandateRegistrationFromExisting": {
        "type": "object",
        "description": "Register a mandate by copying an existing one onto a new customer number.\nUse only where the creditor guidelines permit copying a mandate.\n",
        "required": [
          "basis",
          "customerNumber",
          "newCustomerNumber"
        ],
        "additionalProperties": false,
        "properties": {
          "basis": {
            "type": "string",
            "enum": [
              "existing_mandate"
            ],
            "description": "Registers a mandate copied from an existing one."
          },
          "customerNumber": {
            "type": "string",
            "minLength": 1,
            "maxLength": 15,
            "pattern": "^[A-Za-z0-9]+$",
            "description": "The existing customer number whose mandate is copied.",
            "examples": [
              "1000042"
            ]
          },
          "newCustomerNumber": {
            "type": "string",
            "minLength": 1,
            "maxLength": 15,
            "pattern": "^[A-Za-z0-9]+$",
            "description": "The new customer number to register the copied mandate under.",
            "examples": [
              "1000043"
            ]
          }
        }
      },
      "MandateRegistration": {
        "description": "A single mandate registration — either a fresh registration from the payer's\nbank details (`basis: bank_account`) or a copy of an existing mandate\n(`basis: existing_mandate`).\n",
        "oneOf": [
          {
            "$ref": "#/components/schemas/NewMandateRegistration"
          },
          {
            "$ref": "#/components/schemas/MandateRegistrationFromExisting"
          }
        ],
        "discriminator": {
          "propertyName": "basis",
          "mapping": {
            "bank_account": "#/components/schemas/NewMandateRegistration",
            "existing_mandate": "#/components/schemas/MandateRegistrationFromExisting"
          }
        }
      },
      "MandateRegistrationBatch": {
        "type": "object",
        "description": "A batch of mandate registrations to submit in one delivery.",
        "required": [
          "creditor",
          "registrations"
        ],
        "additionalProperties": false,
        "properties": {
          "creditor": {
            "$ref": "#/components/schemas/Creditor"
          },
          "deliveryReference": {
            "type": "string",
            "minLength": 1,
            "maxLength": 35,
            "description": "Your reference for the whole delivery and the idempotency key. Required for\na real submit (see Idempotency); re-sending the same value replays the\noriginal result and ships nothing new. Optional on a dryRun.\n"
          },
          "registrations": {
            "type": "array",
            "minItems": 1,
            "maxItems": 10000,
            "items": {
              "$ref": "#/components/schemas/MandateRegistration"
            }
          }
        }
      },
      "MandateReceipt": {
        "type": "object",
        "description": "The result of submitting a batch of mandate-lifecycle requests.",
        "required": [
          "deliveryReference",
          "status",
          "acceptedCount",
          "storedAt",
          "filePreview"
        ],
        "additionalProperties": false,
        "properties": {
          "deliveryReference": {
            "type": "string"
          },
          "status": {
            "type": "string",
            "enum": [
              "stored",
              "generated"
            ],
            "description": "`stored` — written to outbound storage, delivered to the bank asynchronously\nover SFTP. `generated` — a dry run, not stored.\n"
          },
          "acceptedCount": {
            "type": "integer",
            "minimum": 0
          },
          "storedAt": {
            "type": [
              "string",
              "null"
            ],
            "format": "date-time"
          },
          "filePreview": {
            "type": [
              "string",
              "null"
            ],
            "description": "On a dry run, the generated delivery as text. Null on a real submission."
          }
        }
      },
      "CustomerNumberChange": {
        "type": "object",
        "description": "Change the customer number a mandate is registered under.",
        "required": [
          "customerNumber",
          "newCustomerNumber"
        ],
        "additionalProperties": false,
        "properties": {
          "customerNumber": {
            "type": "string",
            "minLength": 1,
            "maxLength": 15,
            "pattern": "^[A-Za-z0-9]+$",
            "description": "The payer's existing customer number.",
            "examples": [
              "1000042"
            ]
          },
          "mandateNumber": {
            "type": "string",
            "pattern": "^\\d{1,9}$",
            "description": "The mandate number, if known."
          },
          "newCustomerNumber": {
            "type": "string",
            "minLength": 1,
            "maxLength": 15,
            "pattern": "^[A-Za-z0-9]+$",
            "description": "The payer's new customer number.",
            "examples": [
              "1000043"
            ]
          }
        }
      },
      "CustomerNumberChangeBatch": {
        "type": "object",
        "description": "A batch of customer-number changes to submit in one delivery.",
        "required": [
          "creditor",
          "changes"
        ],
        "additionalProperties": false,
        "properties": {
          "creditor": {
            "$ref": "#/components/schemas/Creditor"
          },
          "deliveryReference": {
            "type": "string",
            "minLength": 1,
            "maxLength": 35,
            "description": "Your reference for the whole delivery and the idempotency key. Required for\na real submit (see Idempotency); re-sending the same value replays the\noriginal result and ships nothing new. Optional on a dryRun.\n"
          },
          "changes": {
            "type": "array",
            "minItems": 1,
            "maxItems": 10000,
            "items": {
              "$ref": "#/components/schemas/CustomerNumberChange"
            }
          }
        }
      },
      "MandateCancellation": {
        "type": "object",
        "description": "Cancel a mandate.",
        "required": [
          "customerNumber",
          "reason"
        ],
        "additionalProperties": false,
        "properties": {
          "customerNumber": {
            "type": "string",
            "minLength": 1,
            "maxLength": 15,
            "pattern": "^[A-Za-z0-9]+$",
            "description": "The payer's customer number.",
            "examples": [
              "1000042"
            ]
          },
          "mandateNumber": {
            "type": "string",
            "pattern": "^\\d{1,9}$",
            "description": "The mandate number, if known."
          },
          "reason": {
            "type": "string",
            "enum": [
              "customer_relationship_ended",
              "unknown_customer_number"
            ],
            "description": "Why the mandate is cancelled. `customer_relationship_ended` — the payer is\nno longer a customer. `unknown_customer_number` — the mandate was\nregistered against a customer number you do not recognise. The reason is\npassed on to the payer's bank.\n"
          }
        }
      },
      "MandateCancellationBatch": {
        "type": "object",
        "description": "A batch of mandate cancellations to submit in one delivery.",
        "required": [
          "creditor",
          "cancellations"
        ],
        "additionalProperties": false,
        "properties": {
          "creditor": {
            "$ref": "#/components/schemas/Creditor"
          },
          "deliveryReference": {
            "type": "string",
            "minLength": 1,
            "maxLength": 35,
            "description": "Your reference for the whole delivery and the idempotency key. Required for\na real submit (see Idempotency); re-sending the same value replays the\noriginal result and ships nothing new. Optional on a dryRun.\n"
          },
          "cancellations": {
            "type": "array",
            "minItems": 1,
            "maxItems": 10000,
            "items": {
              "$ref": "#/components/schemas/MandateCancellation"
            }
          }
        }
      },
      "Health": {
        "type": "object",
        "required": [
          "status"
        ],
        "additionalProperties": false,
        "properties": {
          "status": {
            "type": "string",
            "enum": [
              "ok"
            ]
          },
          "version": {
            "type": "string"
          }
        }
      },
      "InboundCreditor": {
        "type": "object",
        "description": "Which creditor a record belongs to, read from the record itself (the PBS number\nat BS positions 6–13, the debtor group at 21–25).\n\n**A single delivery routinely carries records for SEVERAL creditors.** The bank\npacks one section (012 … 092) per `(pbsNumber, debtorGroupNumber)` into one file,\nso the delivery does NOT identify the creditor — this does. Real example: a BS0603\nwith two sections, one mandate under PBS 30181557 and two under PBS 30185072.\n\nThis matters because **customer and mandate numbers are only unique WITHIN a\ncreditor** — they are assigned by the creditor, not by Betalingsservice. Resolve a\nrecord on `(creditor.pbsNumber, debtor.customerNumber)`, never on\n`customerNumber` alone.\n",
        "required": [
          "pbsNumber",
          "debtorGroupNumber"
        ],
        "additionalProperties": false,
        "properties": {
          "pbsNumber": {
            "type": "string",
            "pattern": "^[1-9]\\d{0,7}$",
            "description": "The creditor number the record was filed under, **with leading zeros\nstripped** — the file pads it to 8 digits, so `09618384` arrives here as\n`9618384`. Strip your own stored value the same way before comparing, or\ncompare numerically; a literal string match against a zero-padded number\nwill silently never hit.\n",
            "examples": [
              "30181557"
            ]
          },
          "debtorGroupNumber": {
            "type": "string",
            "pattern": "^\\d{1,5}$",
            "description": "The debtor group within that creditor. Part of the uniqueness scope for\ncustomer numbers; almost always \"1\" unless the creditor segments debtors.\n",
            "examples": [
              "1"
            ]
          }
        }
      },
      "PaymentOutcome": {
        "type": "object",
        "description": "The outcome of a collection previously submitted, as one line of its creditor's\n`AdviceSection`. Correlate on `reference` (yours) scoped by the section's\n`creditor`.\n\n**Compact by rule, lossless by construction.** A delivery carries thousands of\nthese, and most of what a line could say is the same for every line in the\nfile. So a line states only what is its own, and everything else is implied by\na fixed rule from the delivery and the section:\n\n| Absent | Means |\n| --- | --- |\n| `settled` | for `settled` / `charged_back`: the same as `amount`; for `rejected` / `cancelled`: nothing was settled |\n| `dueDate` | the delivery's `settlementDate` |\n| `settlementDate` | for `settled` / `charged_back`: the delivery's `settlementDate`; for `rejected` / `cancelled`: none |\n| `bookkeepingDate` | the same as the line's settlement date |\n\nThe producer writes a field exactly when its value differs from the rule, so\napplying the rule on your side gives back the original value in every case —\nincluding the unusual ones, such as a `rejected` line that carries `settled`\nbecause already-collected funds were reversed, or a line booked on another day\nthan it settled. All amounts are øre in the delivery's `currency`.\n",
        "required": [
          "reference",
          "mandateNumber",
          "customerNumber",
          "outcome",
          "amount"
        ],
        "additionalProperties": false,
        "properties": {
          "reference": {
            "type": "string",
            "description": "The reference you supplied on the collection. Correlate on this, within the section's creditor."
          },
          "mandateNumber": {
            "type": "string",
            "pattern": "^\\d{1,9}$"
          },
          "customerNumber": {
            "type": "string",
            "description": "The creditor's own number for the debtor — unique only within the section's creditor."
          },
          "outcome": {
            "type": "string",
            "enum": [
              "settled",
              "rejected",
              "cancelled",
              "charged_back"
            ]
          },
          "amount": {
            "type": "integer",
            "minimum": 0,
            "description": "The amount the collection was raised for, in øre."
          },
          "settled": {
            "type": [
              "integer",
              "null"
            ],
            "minimum": 0,
            "description": "The amount actually moved, in øre. Present only when it differs from the\nrule: for `settled` / `charged_back` the rule is `amount`; for `rejected` /\n`cancelled` it is nothing. A `rejected` line with `settled` present is a\nreversal of funds that had already been collected; `null` on a `settled`\nline means the record carried no paid amount at all.\n"
          },
          "dueDate": {
            "type": "string",
            "format": "date",
            "description": "Present only when it differs from the delivery's `settlementDate`."
          },
          "settlementDate": {
            "type": [
              "string",
              "null"
            ],
            "format": "date",
            "description": "When this line's money moved. Present only when it differs from the rule:\nthe delivery's `settlementDate` for `settled` / `charged_back`, none (`null`)\nfor `rejected` / `cancelled`.\n"
          },
          "bookkeepingDate": {
            "type": [
              "string",
              "null"
            ],
            "format": "date",
            "description": "Present only when it differs from the line's settlement date."
          }
        }
      },
      "AdviceSection": {
        "type": "object",
        "description": "One creditor's part of a payment advice: every section (012 … 092) the bank\nfiled for that `(pbsNumber, debtorGroupNumber)` in the delivery, with the\ncollections in them and what the bank actually paid the creditor for them.\nA creditor appears here once even when the file has several physical\nsections for it — automatic payments (0211) and payment slips (0215), say —\nwith their counts and totals added up.\n\nThe bank settles SEPARATELY per creditor, so a consumer settles per section,\nnever per delivery. `totalMinorUnits` is the section-end (092) amount: the\nbank's running total of the paid amounts on every line in the section,\nchargebacks counted as positive and nothing deducted (the bank's own guideline\ncalls it a nonsense total). It is a cross-check against the lines, not the\nmoney the creditor received; sum the settled lines for that. And the creditor\nis stated here ONCE for every line below it: customer numbers and references\nare only unique within a creditor, so a collection means nothing apart from\nits section.\n",
        "required": [
          "creditor",
          "totalMinorUnits",
          "collectionCount",
          "collections"
        ],
        "additionalProperties": false,
        "properties": {
          "creditor": {
            "$ref": "#/components/schemas/InboundCreditor"
          },
          "totalMinorUnits": {
            "type": "integer",
            "minimum": 0,
            "description": "The section-end (092) total in øre, added up over the creditor's\nsections: the sum of the paid amounts on every line, chargebacks included\nas positive. A cross-check figure. It equals the creditor's deposit only\nwhen every line settled.\n"
          },
          "collectionCount": {
            "type": "integer",
            "minimum": 0,
            "description": "How many collection records the creditor's sections carried; equals `collections.length`."
          },
          "collections": {
            "type": "array",
            "description": "Every collection outcome across the creditor's sections, each record once, in file order.",
            "items": {
              "$ref": "#/components/schemas/PaymentOutcome"
            }
          }
        }
      },
      "PaymentAdvice": {
        "type": "object",
        "description": "One BS0602 payment advice, mapped whole — every collection outcome in the file,\ngrouped under the creditor section the bank filed it in. The service does no\nsplitting; the consumer iterates `sections[].collections` for per-charge state.\n\n**One advice covers several creditors.** The bank packs a section per creditor\ninto the delivery and pays each of them separately, so post one settlement per\nsection, keyed on `deliveryReference` + `sections[].creditor`. `totalMinorUnits`\nis the delivery-wide gross across all sections — a cross-check figure, not a\ndeposit anyone received.\n\nThe delivery-level `settlementDate` and `currency` are the defaults every line\nis read against — see `PaymentOutcome` for the rules.\n",
        "required": [
          "subsystem",
          "deliveryReference",
          "settlementDate",
          "currency",
          "totalMinorUnits",
          "sections"
        ],
        "additionalProperties": false,
        "properties": {
          "subsystem": {
            "$ref": "#/components/schemas/Subsystem"
          },
          "deliveryReference": {
            "type": "string",
            "description": "The bank's delivery identification (BS 002/992) — the settlement id."
          },
          "settlementDate": {
            "type": "string",
            "description": "When the bank booked the settlement (ISO), or empty if no line settled. The\ndefault due, settlement and bookkeeping date of every line in the delivery.\n"
          },
          "currency": {
            "type": "string",
            "enum": [
              "DKK"
            ],
            "description": "The currency of every amount in the delivery."
          },
          "totalMinorUnits": {
            "type": "integer",
            "minimum": 0,
            "description": "The whole delivery's total in øre (992), summed across every section in it.\nUse it only as a gross cross-check against the sections — never as a deposit.\n"
          },
          "sections": {
            "type": "array",
            "description": "One entry per creditor section in the delivery, each with that creditor's\ndeposit and its collection outcomes. Post one settlement per entry.\n",
            "items": {
              "$ref": "#/components/schemas/AdviceSection"
            }
          }
        }
      },
      "PaymentAdviceEvent": {
        "type": "object",
        "description": "Delivered once per BS0602 advice file. `data.sections[]` are the per-creditor\ndeposits the bank made, each with its per-charge outcomes — post one settlement\nper section, not one for the delivery.\n",
        "required": [
          "id",
          "type",
          "occurredAt",
          "data"
        ],
        "additionalProperties": false,
        "properties": {
          "id": {
            "type": "string",
            "description": "UUID generated each time an inbound file is processed. Reprocessing the\nsame file creates a new id. Deduplicate on type + data.subsystem +\ndata.deliveryReference only when the delivery reference is non-empty.\nWithout a non-empty reference, this strategy cannot deduplicate the event;\nkeep it.\n"
          },
          "type": {
            "type": "string",
            "enum": [
              "payment.advice"
            ]
          },
          "occurredAt": {
            "type": "string",
            "format": "date-time"
          },
          "data": {
            "$ref": "#/components/schemas/PaymentAdvice"
          }
        },
        "examples": [
          {
            "id": "evt_01HB2X9AAA",
            "type": "payment.advice",
            "occurredAt": "2026-08-04T06:00:00Z",
            "data": {
              "subsystem": "BS2",
              "deliveryReference": "2500859001",
              "settlementDate": "2026-08-04",
              "currency": "DKK",
              "totalMinorUnits": 46395,
              "sections": [
                {
                  "creditor": {
                    "pbsNumber": "30181557",
                    "debtorGroupNumber": "1"
                  },
                  "totalMinorUnits": 26395,
                  "collectionCount": 1,
                  "collections": [
                    {
                      "reference": "INV-2026-000042",
                      "mandateNumber": "94557",
                      "customerNumber": "1000042",
                      "outcome": "settled",
                      "amount": 26395
                    }
                  ]
                },
                {
                  "creditor": {
                    "pbsNumber": "30185072",
                    "debtorGroupNumber": "1"
                  },
                  "totalMinorUnits": 20000,
                  "collectionCount": 2,
                  "collections": [
                    {
                      "reference": "INV-2026-000043",
                      "mandateNumber": "94558",
                      "customerNumber": "1000042",
                      "outcome": "settled",
                      "amount": 20000
                    },
                    {
                      "reference": "INV-2026-000044",
                      "mandateNumber": "94559",
                      "customerNumber": "1000043",
                      "outcome": "rejected",
                      "amount": 15000,
                      "dueDate": "2026-08-03"
                    }
                  ]
                }
              ]
            }
          }
        ]
      },
      "MandateUpdate": {
        "type": "object",
        "description": "A single mandate change within a delivery. `kind` distinguishes a fresh\nregistration (`registered`) from the periodic full active snapshot (`active`)\nand from a cancellation (`cancelled`).\n\n`creditor` says which creditor the mandate is for. One delivery routinely carries\nupdates for several, and `debtor.customerNumber` is only unique within one — so\nlook the debtor up on `(creditor.pbsNumber, debtor.customerNumber)`.\n",
        "required": [
          "creditor",
          "kind",
          "mandateNumber",
          "debtor",
          "status"
        ],
        "additionalProperties": false,
        "properties": {
          "creditor": {
            "$ref": "#/components/schemas/InboundCreditor"
          },
          "kind": {
            "type": "string",
            "enum": [
              "registered",
              "active",
              "cancelled"
            ]
          },
          "mandateNumber": {
            "type": "string",
            "pattern": "^\\d{1,9}$"
          },
          "debtor": {
            "type": "object",
            "required": [
              "customerNumber"
            ],
            "additionalProperties": false,
            "properties": {
              "customerNumber": {
                "type": "string"
              }
            }
          },
          "status": {
            "type": "string",
            "enum": [
              "active",
              "cancelled",
              "expired"
            ]
          },
          "registeredAt": {
            "type": [
              "string",
              "null"
            ],
            "format": "date"
          },
          "cancelledAt": {
            "type": [
              "string",
              "null"
            ],
            "format": "date"
          },
          "cancelledBy": {
            "description": "Who cancelled the mandate (null unless a cancellation).",
            "oneOf": [
              {
                "type": "string",
                "enum": [
                  "debtor",
                  "bank",
                  "creditor",
                  "betalingsservice"
                ]
              },
              {
                "type": "null"
              }
            ]
          }
        }
      },
      "MandateDelivery": {
        "type": "object",
        "description": "One BS0603 mandate delivery, mapped whole — every mandate change in the file as\na single event. The service does no splitting; the consumer iterates `updates`.\n\n`updates` is a flat list spanning **every creditor in the delivery**. Do not treat\nthe delivery as belonging to one creditor: branch on `updates[].creditor`.\n",
        "required": [
          "subsystem",
          "updates"
        ],
        "additionalProperties": false,
        "properties": {
          "subsystem": {
            "$ref": "#/components/schemas/Subsystem"
          },
          "deliveryReference": {
            "type": "string",
            "description": "The bank's delivery identification, when present."
          },
          "updates": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/MandateUpdate"
            }
          }
        }
      },
      "MandateDeliveryEvent": {
        "type": "object",
        "description": "Delivered once per BS0603 mandate file. Iterate `data.updates`; narrow each on\nits `kind`, and route each on its `creditor` — the example below is a real\ndelivery carrying one mandate for PBS 30181557 and two for PBS 30185072.\n",
        "required": [
          "id",
          "type",
          "occurredAt",
          "data"
        ],
        "additionalProperties": false,
        "properties": {
          "id": {
            "type": "string",
            "description": "UUID generated each time an inbound file is processed. Reprocessing the\nsame file creates a new id. Deduplicate on type + data.subsystem +\ndata.deliveryReference only when the delivery reference is non-empty.\nWithout a non-empty reference, this strategy cannot deduplicate the event;\nkeep it.\n"
          },
          "type": {
            "type": "string",
            "enum": [
              "mandate.updated"
            ]
          },
          "occurredAt": {
            "type": "string",
            "format": "date-time"
          },
          "data": {
            "$ref": "#/components/schemas/MandateDelivery"
          }
        },
        "examples": [
          {
            "id": "evt_01HB2X3Y4Z",
            "type": "mandate.updated",
            "occurredAt": "2026-08-01T09:12:00Z",
            "data": {
              "subsystem": "BS2",
              "deliveryReference": "3504159001",
              "updates": [
                {
                  "creditor": {
                    "pbsNumber": "30181557",
                    "debtorGroupNumber": "1"
                  },
                  "kind": "registered",
                  "mandateNumber": "20000101",
                  "debtor": {
                    "customerNumber": "100000000000101"
                  },
                  "status": "active",
                  "registeredAt": "2026-08-24",
                  "cancelledAt": null,
                  "cancelledBy": null
                },
                {
                  "creditor": {
                    "pbsNumber": "30185072",
                    "debtorGroupNumber": "1"
                  },
                  "kind": "registered",
                  "mandateNumber": "20000202",
                  "debtor": {
                    "customerNumber": "10000000000202"
                  },
                  "status": "active",
                  "registeredAt": "2026-08-24",
                  "cancelledAt": null,
                  "cancelledBy": null
                }
              ]
            }
          }
        ]
      },
      "BatchReceipt": {
        "type": "object",
        "description": "A delivery-level acknowledgement from the bank — whether a submitted batch\npassed validation. `deliveryReference` is the bank-assigned delivery number\n(`TILDELT LEVERANCE NR`). On rejection, `code` is the `BSxx` status code and\n`detail` is the human-readable reason.\n\nOne more source of a rejection: the bank's gateway refuses an upload before it\nbecomes a delivery and answers with a notice named `<our file name>.ERROR`.\nThat is published as `batch.rejected` with `code` null, `detail` naming the\ngateway's validation error, and `deliveryReference` = the reference the upload\nwas filed under (our outbound file is named after it), since no bank delivery\nnumber exists.\n",
        "required": [
          "subsystem",
          "deliveryReference",
          "outcome",
          "receivedAt",
          "code",
          "detail"
        ],
        "additionalProperties": false,
        "properties": {
          "subsystem": {
            "$ref": "#/components/schemas/Subsystem"
          },
          "deliveryReference": {
            "type": "string",
            "description": "The bank-assigned delivery number on a PBCNET41 receipt; your submitted\ndeliveryReference on a gateway .ERROR rejection; empty if neither exists.\n"
          },
          "outcome": {
            "type": "string",
            "enum": [
              "accepted",
              "rejected"
            ]
          },
          "receivedAt": {
            "type": "string",
            "format": "date-time"
          },
          "code": {
            "type": [
              "string",
              "null"
            ],
            "description": "The BSxx status code (e.g. BS00 accepted, BS13 rejected).",
            "examples": [
              "BS13"
            ]
          },
          "detail": {
            "type": [
              "string",
              "null"
            ],
            "description": "The human-readable status / rejection reason.",
            "examples": [
              "BS13: DATALEVERANDØR UKENDT I GT; erroneous record #1"
            ]
          }
        }
      },
      "BatchReceiptEvent": {
        "type": "object",
        "description": "Delivered when the bank validates a submitted batch. Correlate via\n`data.deliveryReference` only when it is non-empty. Reference-less receipts\ncannot be deduplicated this way and must be kept.\n",
        "required": [
          "id",
          "type",
          "occurredAt",
          "data"
        ],
        "additionalProperties": false,
        "properties": {
          "id": {
            "type": "string",
            "description": "UUID generated each time an inbound file is processed. Reprocessing the\nsame file creates a new id. Deduplicate on type + data.subsystem +\ndata.deliveryReference only when the delivery reference is non-empty.\nReference-less receipts have no dedupe key under this strategy and must\nbe kept; do not use a shared key such as batch.rejected:BS1:.\n"
          },
          "type": {
            "type": "string",
            "description": "The concrete event type — use as the discriminant.",
            "enum": [
              "batch.accepted",
              "batch.rejected"
            ]
          },
          "occurredAt": {
            "type": "string",
            "format": "date-time"
          },
          "data": {
            "$ref": "#/components/schemas/BatchReceipt"
          }
        },
        "examples": [
          {
            "id": "evt_01HB2XBBBB",
            "type": "batch.rejected",
            "occurredAt": "2026-08-01T09:20:00Z",
            "data": {
              "subsystem": "BS2",
              "deliveryReference": "2499147001",
              "outcome": "rejected",
              "receivedAt": "2026-08-01T09:20:00Z",
              "code": "BS13",
              "detail": "BS13: DATALEVERANDØR UKENDT I GT; erroneous record #1"
            }
          }
        ]
      }
    },
    "responses": {
      "BadRequest": {
        "description": "The request was malformed or failed validation.",
        "content": {
          "application/problem+json": {
            "schema": {
              "$ref": "#/components/schemas/Problem"
            }
          }
        }
      },
      "InternalError": {
        "description": "The delivery could not be built or written to storage; nothing was sent.",
        "content": {
          "application/problem+json": {
            "schema": {
              "$ref": "#/components/schemas/Problem"
            }
          }
        }
      }
    }
  }
};
